import { AnchorProvider, Program } from '@coral-xyz/anchor';
import { PublicKey } from '@solana/web3.js';
import { bytesToHex } from '@train-protocol/sdk';
import { NATIVE_SOL_ADDRESS } from '../constants.js';
import { TrainHtlc } from '../idl/trainHtlc.js';
export function parseSecret(secretBytes) {
    return BigInt(bytesToHex(Array.from(secretBytes)));
}
export function buildReadOnlyProvider(publicKey, connection) {
    const wallet = {
        publicKey,
        signTransaction: async (tx) => tx,
        signAllTransactions: async (txs) => txs,
    };
    return new AnchorProvider(connection, wallet, AnchorProvider.defaultOptions());
}
export function buildProgram(contractAddress, connection, readerKey) {
    const pk = readerKey ?? new PublicKey(NATIVE_SOL_ADDRESS);
    const provider = buildReadOnlyProvider(pk, connection);
    return new Program(TrainHtlc(contractAddress), provider);
}
